import React, { Component } from 'react'
import { Input, Row, Col } from "reactstrap"
import SideNav from './SideNav'
import Upload from './Upload';
import Text from './InfoType.js/Text';
import Url from './InfoType.js/Url';
import File from './InfoType.js/File';
import Image from './InfoType.js/Image';
import Youtube from './InfoType.js/Youtube';
import axios from "axios";
import Loading from './Loading';

const debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export default class Mason extends Component {
    state ={
        files:[],
        search: "",
        loading: true,
        searchRes: [],
        isEmpty: false,
        loading2:false,
        searching: false,
    }
    componentDidMount() {
        if (localStorage.getItem('token') === null){
            this.props.history.push("/login");
        }
        else{
           this.getInfoFromDb();
        }
    }
    getInfoFromDb = () =>{
        const auth = {
            user_id: localStorage.getItem("token"),
            group_id: this.props.match.params.group
        };
        console.log(auth)
        axios.post("https://azure.ratemycourse.review/group/files/", auth)
        .then(res => {
            this.setState({files: res.data.filter(Boolean), loading:false})
        })
    }
    SearchInputHandler = (e) =>{
        if (e.target.value === ""){
            this.setState({searching: false})
        }else{
            this.onChangeSearch(e);
        }
        this.setState({search:e.target.value});
       
    }
    
    onChangeSearch = debounce(async (e) => {
        this.setState({loading2: true, searching: true});
        if (e.target.value !== "") {
            const searchBody ={
                user_id: localStorage.getItem("token"),
                query: e.target.value
            }
            const result = await axios.post(`https://azure.ratemycourse.review/search/`, searchBody);
            console.log(result.data);            
            if (result.data.length > 0) {
                this.setState({searchRes: result.data, loading2: false});
            } else {
                this.setState({ searchRes: [], isEmpty: true, loading2: false});
            }
        } else {
            this.setState({ suggestions: [], isEmpty: false, loading: false, searching: false });
        }

    }, 400)
    setLoad = () => {
        this.setState({loading: true});
    }
    render() {
        return (
            <div>
                <Row className={"justify-content-center mt-4"} >
                <Col md="2">
                <Row className="justify-content-center h3" style={{color:"#6056A0", fontSize:"40px"}}>
                    Void
                </Row>
                </Col>
                <Col md="9">
                <Input 
                className={"ml-5 form-control shadow-sm"}
                type="text"
                placeholder="Search for anything" 
                aria-label="Search"
                name="search"
                value={this.state.search}
                onChange={this.SearchInputHandler}
                />
                </Col>
                <Col></Col>
                </Row>

               {this.state.loading? <Loading />: <Row className="mt-4">
                    <Col md="2">
                        <SideNav />
                    </Col>
                   
                    {!this.state.searching? <Col md="9" className="ml-5">
                        <Upload load={this.setLoad} reload={this.getInfoFromDb}/>
                        <div className="card-columns mt-3">
                            {this.state.files.map((info, i) => (
                                <div key={i}>
                                    {info.type === "text" && <Text info={info}/>}
                                    {info.type === "website" && <Url info={info}/>}
                                    {info.type === "file" && <File info={info}/>}
                                    {info.type === "document" && <File info={info}/>}
                                    {info.type === "image" && <Image info={info}/>}
                                    {info.type === "youtube" && <Youtube info={info}/>}
                                </div>
                            ))}
                        </div>
                    </Col>:
                    <Col md="9" className="ml-5">
                   <div className="card-columns mt-3">
                           {this.state.loading2? <Loading />:
                           <div>
                            {this.state.searchRes.map((info, i) => (
                                <div key={i}>
                                    {info.type === "text" && <Text info={info}/>}
                                    {info.type === "website" && <Url info={info}/>}
                                    {info.type === "file" && <File info={info}/>}
                                    {info.type === "image" && <Image info={info}/>}
                                    {info.type === "youtube" && <Youtube info={info}/>}
                                </div>
                            ))}
                            {this.state.isEmpty && 
                             <div className="d-flex align-items-center justify-content-center h-100">
                             <div className="d-flex flex-column">
                             No results found.
                             </div>
                           </div>
                            }
                            </div>}
                        </div>
                </Col>}

                </Row>}
            </div >
        )
    }
}
